module.exports = __webpack_public_path__ + "static/media/Hoddept.1a059c5f.jpg";